import React from 'react';
import { motion } from 'framer-motion';
import './styles.scss';
import { CalendarDays, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

const EventsListing = () => {
	const { t } = useTranslation();

	const events = [
		{
			id: 1,
			date: t('events.date'),
			title: t('events.itemTitle'),
			location: t('events.location'),
			description: t('events.desc'),
			image: '/assets/ik/ik1.jpg',
		},
	];

	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				staggerChildren: 0.2,
			},
		},
	};

	const itemVariants = {
		hidden: { y: 20, opacity: 0 },
		visible: {
			y: 0,
			opacity: 1,
			transition: { duration: 0.5 },
		},
	};

	return (
		<section className='events'>
			<div className='container'>
				<h2 className='title events__title'>{t('events.title')}</h2>

				<motion.div
					className='events__list'
					variants={containerVariants}
					initial='hidden'
					animate='visible'
				>
					{events.map((event) => (
						<motion.article
							key={event.id}
							className={`events__item ${
								event.isPast ? 'events__item--past' : ''
							}`}
							variants={itemVariants}
							whileHover={{ y: -5 }}
						>
							{event.image && (
								<div className='events__image-wrapper'>
									<img
										src={event.image}
										alt={event.title}
										className='events__image'
									/>
								</div>
							)}

							<div className='events__content'>
								<div className='events__meta'>
									<span className='events__date'>
										<CalendarDays size={16} />
										{event.date}
									</span>
									<span className='events__location'>
										<MapPin size={16} />
										{event.location}
									</span>
								</div>

								<h3 className='events__item-title'>{event.title}</h3>
								<p className='events__description'>{event.description}</p>

								<div className='events__links'>
									<Link to={`/events/${event.id}`} className='events__link'>
										{t('events.more...')}
									</Link>
								</div>
							</div>
						</motion.article>
					))}
				</motion.div>
			</div>
		</section>
	);
};

export default EventsListing;
